module.exports = __webpack_public_path__ + "img/section_icon_04.fb3dff20.png";